import React from 'react'
import { connect } from 'react-redux'

const TitleWrap = ({ pageTitle, children }) => {
  return (
    <>
      {pageTitle && dynamicValues.newSiteLook ? (
        <div className="titlewrap">
          <div className="container">
            <h1 id="pagetitle">
              <span>{pageTitle}</span>
            </h1>
          </div>
        </div>
      ) : null}
      {children}
    </>
  )
}

export default connect(
  state => {
    return state.pageInfo
  },
  dispatch => ({
    dispatch
  })
)(TitleWrap)
